import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map, List, fromJS } from 'immutable'
import { withRouter } from 'react-router'
import { Loader, Dimmer } from 'semantic-ui-react'
import { replace, push } from 'react-router-redux'
import QueryString from 'query-string'
import Helmet from 'react-helmet'
import Store from 'store'

import Api from '~/api'
import { dataTableItemsFetch, dataTableItemsFetchLoading, dataTableConfigFetch } from './actions'
import Table from './views/table'
import Controls from './views/controls'
import Header from './views/header'
import Create from './views/create'
import Edit from './views/edit'
import Filters from './views/filters'

let directionFix = {
  asc: 'ascending',
  desc: 'descending',
}

let actionStates = ['create', 'edit', 'close', 'refetch']
let fetchAttributes = ['filters', 'limit', 'sortBy', 'sortDir', 'search', 'page', 'filter', 'refetch']

let wait = fn => {
  let threshhold = 300
  let deferTimer = undefined

  return function () {
    let args = arguments
    if (deferTimer) clearTimeout(deferTimer)

    deferTimer = setTimeout(function () {
      fn.apply(this, args)
    }, threshhold)
  }
}

export function serializeFilters(filters) {
  if (typeof filters !== 'object' || !Object.keys(filters).length) return ''

  let str = []

  for (let key in filters) {
    if (!key || key.trim() === '' || key === undefined || key === 'undefined') continue

    let value = filters[key]
    if (Array.isArray(value) || List.isList(value)) value = value.join(',')
    str.push(`${key}:${value}`)
  }

  return str.join('|')
}

export function deserializeFilters(str) {
  if (typeof str !== 'string') return {}

  return str.split('|').reduce((filters, s) => {
    if (typeof s !== 'string') return filters

    let [key = '', value = ''] = s.split(':')

    if (key !== '' && value !== '') filters[key] = value.split(',')

    return filters
  }, {})
}

function setLocalFilters(id, filters) {
  let localFilters = Store.get('alustaFilters') || {}
  localFilters[id] = filters
  Store.set('alustaFilters', localFilters)
}

function getLocalFilters(id) {
  let localFilters = Store.get('alustaFilters') || {}
  return localFilters[id] || false
}

class DataTableContainer extends Component {
  state = {
    sortDir: 'asc',
    sortBy: '',
    groupBy: '',
    page: 1,
    limit: 25,
    searchData: Map(),
    search: '',
    query: '',
    action: false,
    filters: '',
  }

  constructor(props) {
    super(props)

    if (!props.entity) throw Error('entity not defined')

    let {
      columns = [],
      limit = false,
      page = false,
      sortDir = false,
      groupBy = false,
      defaultFilters = false,
      id,
      disableLocalFilters = false,
    } = props

    for (let column of columns) {
      if (column.defaultSort && !this.state.sortBy) this.state.sortBy = column.name
    }

    if (limit) this.state.limit = limit

    if (sortDir) this.state.sortDir = sortDir

    if (groupBy) this.state.groupBy = groupBy

    if (page) this.state.page = page

    let localFilters = getLocalFilters(id)
    if (localFilters && !disableLocalFilters) {
      this.state.filters = localFilters
    } else if (defaultFilters) {
      this.state.filters = serializeFilters(defaultFilters)
    }
  }

  componentDidMount = () => {
    let { id, entity, fetchConfig } = this.props
    fetchConfig(id, { entity })

    this.syncLocation({}, true)
  }

  componentWillReceiveProps = nextProps => {
    let { id, entity, fetchItems, apiPath } = this.props

    let { query } = this.state
    let { location } = nextProps

    if (location.search !== query) {
      let curState = QueryString.parse(query)
      let nextState = QueryString.parse(location.search || '')
      let shouldFetch = fetchAttributes.reduce(
        (should, key) => (curState[key] !== nextState[key] ? should + 1 : should),
        0
      )

      if (shouldFetch) fetchItems(id, { entity, ...nextState }, apiPath)

      let stateUpdate = {
        query: location.search,
      }

      if (curState.action !== nextState.action) stateUpdate.action = nextState.action

      if (curState.editId !== nextState.editId) stateUpdate.editId = nextState.editId

      this.setState(stateUpdate)
    }
  }

  startSearch = wait(start => start())

  syncLocation = (update = {}, init = false) => {
    let {
      columns,
      location,
      replaceLocation,
      pushLocation,
      id,
      entity,
      fetchItems,
      apiPath,
      disableLocalFilters = false,
      limit: defaultLimit = 50,
    } = this.props

    let dataState = QueryString.parse(location.search || '')

    dataState.limit = update.limit !== undefined ? update.limit : dataState.limit ? dataState.limit : defaultLimit
    dataState.sortBy =
      update.sortBy !== undefined ? update.sortBy : dataState.sortBy ? dataState.sortBy : this.state.sortBy
    dataState.sortDir =
      update.sortDir !== undefined ? update.sortDir : dataState.sortDir ? dataState.sortDir : this.state.sortDir
    dataState.groupBy =
      update.groupBy !== undefined ? update.groupBy : dataState.groupBy ? dataState.groupBy : this.state.groupBy
    dataState.search = update.search !== undefined ? update.search : dataState.search ? dataState.search : ''
    dataState.page = update.page !== undefined ? update.page : dataState.page ? dataState.page : 1
    dataState.filters =
      update.filters !== undefined ? update.filters : dataState.filters ? dataState.filters : this.state.filters

    if (!columns.find(({ name }) => name === dataState.sortBy)) delete dataState.sortBy

    this.setState(dataState)

    if (!disableLocalFilters) setLocalFilters(id, dataState.filters)

    location.search = QueryString.stringify(dataState)
    init ? replaceLocation(location) : pushLocation(location)
    // init ? fetchItems(id, { entity, ...dataState }, apiPath) : null
  }

  handleSearch = search => {
    let { setLoading, id } = this.props
    setLoading(id, true)
    this.setState({ search })
    this.startSearch(() => this.syncLocation({ search }))
  }

  handleAction = (action, vars = {}) => {
    let { location, pushLocation, replaceLocation, id } = this.props

    if (typeof action === 'function') return action()

    if (actionStates.indexOf(action) > -1) {
      let dataState = QueryString.parse(location.search || '')
      let push = true

      if (action === 'edit') {
        if (dataState.editId === vars.id) {
          delete dataState.editId
        } else {
          dataState.editId = vars.id
        }
      } else if (action === 'refetch') {
        dataState.refetch = new Date().getTime()
        push = false
      } else if (action === 'close' || dataState.action === action) {
        delete dataState.action
        delete dataState.editId
      } else {
        dataState.action = action
      }

      location.search = QueryString.stringify(dataState)
      replaceLocation(location)
      // push ? pushLocation(location) : replaceLocation(location)
    }
  }

  changePage = page => {
    let { id, dataTable = Map() } = this.props

    let meta = dataTable.getIn([id, 'meta'], Map())

    if (page === 'next') {
      page = meta.get('currentPage') + 1
      if (page > meta.get('pages')) return
    }

    if (page === 'prev') {
      page = meta.get('currentPage') - 1
      if (page < 1) return
    }

    this.syncLocation({ page })
  }

  setLimit = limit => {
    limit = parseInt(limit)
    if (isNaN(limit) || limit < 0) return

    let { id, dataTable = Map() } = this.props

    if (dataTable.getIn([id, 'meta', 'limit']) === limit) return

    this.syncLocation({ limit })
  }

  handleFilterChange = filters => {
    console.log('Update filters', filters)
  }

  render = () => {
    let {
      columns = [],
      actions = [],
      dataTable = Map(),
      dataId = 'id',
      id,
      entity,
      crud = false,
      texts = {},
      editComponent = false,
      editWide = false,
      filters: enableFilters = false,
      filterFields = [],
      context = {},
      title = false,
      children,
    } = this.props

    let items = dataTable.getIn([id, 'items'], List())
    let meta = dataTable.getIn([id, 'meta'], Map())
    let config = dataTable.getIn([id, 'config'], Map())
    let configLoading = dataTable.getIn([id, 'configLoading'], true)
    let loading = dataTable.getIn([id, 'fetchLoading'], true)

    let { limit, sortBy, sortDir, search, page, action, editId, groupBy, filters } = this.state

    let editItem = editId ? items.find(i => i.get(dataId) === editId) : false

    return (
      <div className="datatable">
        {title ? (
          <Helmet>
            <title>{title}</title>
          </Helmet>
        ) : null}
        <Header
          search={search}
          onSearch={this.handleSearch}
          actions={actions}
          crud={crud}
          texts={texts}
          filters={enableFilters ? filters : false}
          items={items}
          columns={columns}
          id={id}
          onAction={this.handleAction}
        />
        {enableFilters ? (
          <Filters
            filterFields={filterFields}
            filtersString={filters}
            filters={deserializeFilters(filters)}
            onChange={filters => this.syncLocation({ filters: serializeFilters(filters) })}
          />
        ) : null}
        <div className="datatable-table-wrapper">
          <Table
            dataId={dataId}
            data={items}
            columns={columns}
            crud={crud}
            texts={texts}
            editId={editId}
            editing={editItem !== false}
            sort={(sortBy, nextSortDir = false) => this.syncLocation({ sortBy, sortDir: nextSortDir || sortDir })}
            onAction={this.handleAction}
            context={context}
            groupBy={groupBy}
            sortBy={sortBy}
            sortDir={sortDir}
          />
          {loading ? (
            <Dimmer active inverted>
              <Loader />
            </Dimmer>
          ) : null}
        </div>
        <Controls meta={meta} changePage={this.changePage} setLimit={this.setLimit} />
        {configLoading || !crud ? null : action === 'create' ? (
          <Create config={config} table_id={id} entity={entity} onCancel={() => this.handleAction('close')} />
        ) : null}
        <Edit
          active={editItem !== false}
          config={config}
          tableId={id}
          entity={entity}
          item={editItem}
          itemId={editId}
          dataId={dataId}
          editComponent={editComponent}
          wide={editWide}
          onCancel={() => this.handleAction('close')}
        />
        {children}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    dataTable: state.dataTable,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchConfig: (table_id, config) => dispatch(dataTableConfigFetch(table_id, config)),
    fetchItems: (table_id, config, apiPath) => dispatch(dataTableItemsFetch(table_id, config, apiPath)),
    setLoading: (table_id, loading = true) => dispatch(dataTableItemsFetchLoading(table_id, loading)),
    replaceLocation: location => dispatch(replace(location)),
    pushLocation: location => dispatch(push(location)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTableContainer))
